export default [
  {
    "id": "mat-enem-0045",
    "numero": 1545,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Um casal decidiu que vai ter 3 filhos. Contudo, \nquer exatamente 2 filhos homens e decide que, \nse a probabilidade fosse inferior a 50%, iria pro-\ncurar uma clínica para fazer um tratamento es-\npecífico para garantir que teria os dois filhos \nhomens. Após os cálculos, o casal concluiu que \na probabilidade de ter exatamente 2 filhos ho-\nmens é: \n \nA) 66,7%, assim ele não precisará fazer um \ntratamento. \nB) 50%, assim ele não precisará fazer um tra-\ntamento. \nC) 7,5%, assim ele não precisará fazer um tra-\ntamento. \nD) 25%, assim ele precisará procurar uma clíni-\nca para fazer um tratamento. \nE) 37,5%, assim ele precisará procurar uma \nclínica para fazer um tratamento.",
    "alternativas": {
      "C": "7,5%, assim ele não precisará fazer um tra- tamento.",
      "D": "25%, assim ele precisará procurar uma clíni- ca para fazer um tratamento.",
      "E": "37,5%, assim ele precisará procurar uma clínica para fazer um tratamento.",
      "B": "50%, assim ele não precisará fazer um tra- tamento."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 45,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0046",
    "numero": 1546,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Dados da Associação Nacional de Empresas de \nTransportes Urbanos (ANTU) mostram que o \nnúmero de passageiros transportados mensal-\nmente nas principais regiões metropolitanas do \npaís vem caindo sistematicamente.  \n \nEram 476,7 milhões de passageiros em 1995, e \nesse número caiu para 321,9 milhões em abril \nde 2001. Nesse período, o tamanho da frota de \nveículos mudou pouco, tendo no final de 2008 \npraticamente o mesmo tamanho que tinha em \n2001. \n \nO gráfico a seguir mostra um índice de produti-\nvidade utilizado pelas empresas do setor, que é \na razão entre o total de passageiros transporta-\ndos por dia e o tamanho da frota de veículos. \n \n \n \n \nSupondo que as frotas totais de veículos naquelas regiões metropolitanas em abril de 2001 e em outubro \nde 2008 eram do mesmo tamanho, os dados do gráfico permitem inferir que o total de passageiros \ntransportados no mês de outubro de 2008 foi aproximadamente igual a: \n \nA) 355 milhões.     \nB) 400 milhões.     \nC) 426 milhões.      \nD) 441 milhões.       \nE) 477 milhões.",
    "alternativas": {
      "C": "426 milhões.",
      "D": "441 milhões.",
      "E": "477 milhões.",
      "A": "355 milhões."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 46,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0047",
    "numero": 1547,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "O mapa ao lado representa um bairro de deter-\nminada cidade, no qual as flechas indicam o \nsentido das mãos do tráfego. Sabe-se que esse \nbairro foi planejado e que cada quadra repre-\nsentada na figura é um terreno quadrado, de \nlado igual a 200 metros. \n \n \n \nDesconsiderando-se a largura das ruas, qual \nseria o tempo, em minutos, que um ônibus, em \nvelocidade constante e igual a 40 km/h, partindo \ndo ponto X, demoraria para chegar até o ponto \nY? \n \nA) 25 min.         \nB) 15 min.        \nC) 2,5 min.        \nD) 1,5 min.           \nE) 0,15 min. \n \n \nTexto para as questões 48 e 49 \n \nA população mundial está ficando mais velha, \nos índices de natalidade diminuíram e a expec-\ntativa de vida aumentou. No gráfico seguinte, \nsão apresentados dados obtidos por pesquisa \nrealizada pela Organização das Nações Unidas \n(ONU), a respeito da quantidade de pessoas \ncom 60 anos ou mais em todo o mundo. Os \nnúmeros da coluna da direita representam as \nfaixas percentuais. Por exemplo, em 1950 havia \n95 milhões de pessoas com 60 anos ou mais \nnos países desenvolvidos, número entre 10% e \n15% da população total nos países desenvolvi-\ndos.",
    "alternativas": {
      "A": "25 min.",
      "B": "15 min.",
      "D": "1,5 min.",
      "E": "0,15 min. Texto para as questões 48 e 49 A população mundial está ficando mais velha, os índices de natalidade diminuíram e a expec- tativa de vida aumentou. No gráfico seguinte, são apresentados dados obtidos por pesquisa realizada pela Organização das Nações Unidas (ONU), a respeito da quantidade de pessoas com 60 anos ou mais em todo o mundo. Os números da coluna da direita representam as faixas percentuais. Por exemplo, em 1950 havia 95 milhões de pessoas com 60 anos ou mais nos países desenvolvidos, número entre 10% e 15% da população total nos países desenvolvi- dos."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 47,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0048",
    "numero": 1548,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Suponha que o modelo exponencial seja igual a \ny = 363e0,03x, em que x = 0 corresponde ao ano \n2000, x = 1 corresponde ao ano 2001, e assim \nsucessivamente, e que y é a população em \nmilhões de habitantes no ano x, seja usado para \nestimar essa população com 60 anos ou mais \nde idade nos países em desenvolvimento entre \n2010 e 2050.  \n \nDesse modo, considerando o valor e0,3 = 35 \nestima-se que a população com 60 anos ou \nmais estará, em 2030, entre: \n \nA) 490 e 510 milhões.   \nB) 550 e 620 milhões. \nC) 780 e 800 milhões. \nD) 810 e 860 milhões. \nE) 870 e 910 milhões.",
    "alternativas": {
      "A": "490 e 510 milhões.",
      "B": "550 e 620 milhões.",
      "C": "780 e 800 milhões.",
      "E": "870 e 910 milhões."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 48,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0049",
    "numero": 1549,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Em 2050, a probabilidade de se escolher, alea-\ntoriamente, uma pessoa com 60 anos ou mais \nde idade, na população dos países desenvolvi-\ndos, será um número mais próximo de: \n \nA) 1/2.              \nB) 7/20.                \nC) 8/25.         \nD) 1/5.               \nE) 3/25.",
    "alternativas": {
      "C": "8/25.",
      "D": "1/5.",
      "A": "1/2.",
      "B": "7/20."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 49,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0050",
    "numero": 1550,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "O governo cedeu terrenos para que famílias \nconstruíssem suas residências com a condição \nde que no mínimo 94% da área do terreno fosse \nmantida como área de preservação ambiental. \nAo receber o terreno retangular ABCD, em que \nAB = BC/2, Antônio demarcou uma área qua-\ndrada no vértice A, para a construção de sua \nresidência, de acordo com o desenho, no qual \nAE = AB/5 é lado do quadrado. \n \n \n \nNesse caso, a área definida por Antônio atingiria \nexatamente o limite determinado pela condição \nse ele: \n \nA) duplicasse a medida do lado do quadrado. \nB) triplicasse a medida do lado do quadrado. \nC) triplicasse a área do quadrado. \nD) ampliasse a medida do lado do quadrado em 4%. \nE) ampliasse a área do quadrado em 4%.",
    "alternativas": {
      "B": "triplicasse a medida do lado do quadrado.",
      "C": "triplicasse a área do quadrado.",
      "D": "ampliasse a medida do lado do quadrado em 4%.",
      "E": "ampliasse a área do quadrado em 4%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 50,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0051",
    "numero": 1551,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Uma resolução do Conselho Nacional de Políti-\nca Energética (CNPE) estabeleceu a obrigatori-\nedade de adição de biodiesel ao óleo diesel \ncomercializado nos postos. A exigência é que, a \npartir de 1.º de julho de 2009, 4% do volume da \nmistura final seja formada por biodiesel. Até \njunho de 2009, esse percentual era de 3%. Essa \nmedida estimula a demanda de biodiesel, bem \ncomo possibilita a redução da importação de \ndiesel de petróleo. \n \nEstimativas indicam que, com a adição de 4% \nde biodiesel ao diesel, serão consumidos 925 \nmilhões de litros de biodiesel no segundo se-\nmestre de 2009. Considerando-se essa estima-\ntiva, para o mesmo volume da mistura final die-\nsel/biodiesel consumida no segundo semestre \nde 2009, qual seria o consumo de biodiesel com \na adição de 3%? \n \nA) 27,75 milhões de litros. \nB) 37,00 milhões de litros. \nC) 231,25 milhões de litros. \nD) 693,75 milhões de litros. \nE) 888,00 milhões de litros.",
    "alternativas": {
      "A": "27,75 milhões de litros.",
      "C": "231,25 milhões de litros.",
      "D": "693,75 milhões de litros.",
      "E": "888,00 milhões de litros."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 51,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0052",
    "numero": 1552,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A suspeita de que haveria uma relação causal entre tabagismo e câncer de pulmão foi levantada pela \nprimeira vez a partir de observações clínicas. Para testar essa possível associação, foram conduzidos \ninúmeros estudos epidemiológicos. Dentre esses, houve o estudo do número de casos de câncer em \nrelação ao número de cigarros consumidos por dia, cujos resultados são mostrados no gráfico a seguir. \n \n \n \nDe acordo com as informações do gráfico, \n \nA) o consumo diário de cigarros e o número de casos de câncer de pulmão são grandezas inversamente \nproporcionais. \nB) o consumo diário de cigarros e o número de casos de câncer de pulmão são grandezas que não se \nrelacionam. \nC) o consumo diário de cigarros e o número de casos de câncer de pulmão são grandezas diretamente \nproporcionais. \nD) uma pessoa não fumante certamente nunca será diagnosticada com câncer de pulmão. \nE) o consumo diário de cigarros e o número de casos de câncer de pulmão são grandezas que estão \nrelacionadas, mas sem proporcionalidade.",
    "alternativas": {
      "A": "o consumo diário de cigarros e o número de casos de câncer de pulmão são grandezas inversamente proporcionais.",
      "B": "o consumo diário de cigarros e o número de casos de câncer de pulmão são grandezas que não se relacionam.",
      "D": "uma pessoa não fumante certamente nunca será diagnosticada com câncer de pulmão.",
      "E": "o consumo diário de cigarros e o número de casos de câncer de pulmão são grandezas que estão relacionadas, mas sem proporcionalidade."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 52,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0053",
    "numero": 1553,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "O gráfico a seguir mostra a evolução, de abril de 2008 a maio de 2009, da população economicamente \nativa para seis Regiões Metropolitanas pesquisadas. \nConsiderando que a taxa de crescimento da \npopulação economicamente ativa, entre 05/09 e \n06/09, seja de 4%, então o número de pessoas \neconomicamente ativas em 06/09 será igual a: \n \nA) 23.940.    \nB) 32.228.      \nC) 920.800.       \nD) 23.940.800.      \nE) 32.228.000.",
    "alternativas": {
      "B": "32.228.",
      "C": "920.800.",
      "D": "23.940.800.",
      "A": "23.940."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 53,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0054",
    "numero": 1554,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A música e a matemática se encontram na re-\npresentação dos tempos das notas musicais, \nconforme a figura seguinte. \n \n \n \nUm compasso é uma unidade musical composta \npor determinada quantidade de notas musicais \nem que a soma das durações coincide com a \nfração indicada como fórmula do compasso. Por \nexemplo, se a fórmula de compasso for 1/2, \npoderia ter um compasso ou com duas semíni-\nmas ou uma mínima ou quatro colcheias, sendo \npossível a combinação de diferentes figuras.  \n \nUm trecho musical de oito compassos, cuja \nfórmula é 3/4, poderia ser preenchido com: \n \nA) 24 fusas. \nB) 3 semínimas. \nC) 8 semínimas. \nD) 24 colcheias e 12 semínimas. \nE) 16 semínimas e 8 semicolcheias.",
    "alternativas": {
      "C": "8 semínimas.",
      "D": "24 colcheias e 12 semínimas.",
      "A": "24 fusas.",
      "B": "3 semínimas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 54,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0055",
    "numero": 1555,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "O controle de qualidade de uma empresa fabri-\ncante de telefones celulares aponta que a pro-\nbabilidade de um aparelho de determinado mo-\ndelo apresentar defeito de fabricação é de 0,2%. \nSe uma loja acaba de vender 4 aparelhos desse \nmodelo para um cliente, qual é a probabilidade \nde esse cliente sair da loja com exatamente dois \naparelhos defeituosos? \n \nA) 2 × (0,2%)4 \nB) 4 × (0,2%)2 \nC) 6 × (0,2%)2 × (99,8%)2 \nD) 4 × (0,2%)  \nE) 6 × (0,2%) × (99,8%)",
    "alternativas": {
      "C": "6 × (0,2%)2 × (99,8%)2",
      "D": "4 × (0,2%)",
      "E": "6 × (0,2%) × (99,8%)",
      "B": "4 × (0,2%)2"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 55,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0056",
    "numero": 1556,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Uma pousada oferece pacotes promocionais \npara atrair casais a se hospedarem por até oito \ndias. A hospedagem seria em apartamento de \nluxo e, nos três primeiros dias, a diária custaria \nR$ 150,00, preço da diária fora da promoção. \nNos três dias seguintes, seria aplicada uma \nredução no valor da diária, cuja taxa média de \nvariação, a cada dia, seria de R$ 20,00. Nos \ndois dias restantes, seria mantido o preço do \nsexto dia.  \n \nNessas condições, um modelo para a promoção \nidealizada é apresentado no gráfico a seguir, no \nqual o valor da diária é função do tempo medido \nem número de dias. \n \n \n \nDe acordo com os dados e com o modelo, com-\nparando o preço que um casal pagaria pela \nhospedagem por sete dias fora da promoção, \num casal que adquirir o pacote promocional por \noito dias fará uma economia de: \n \nA) R$ 90,00.       \nB) R$ 110,00.      \nC) R$ 130,00.      \nD) R$ 150,00.       \nE) R$ 170,00.",
    "alternativas": {
      "E": "R$ 170,00.",
      "A": "R$ 90,00.",
      "C": "R$ 130,00.",
      "D": "R$ 150,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 56,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0057",
    "numero": 1557,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "As figuras a seguir exibem um trecho de um \nquebra-cabeças que está sendo montado. Ob-\nserve que as peças são quadradas e há 8 peças \nno tabuleiro da figura A e 8 peças no tabuleiro \nda figura B. As peças são retiradas do tabuleiro \nda figura B e colocadas no tabuleiro da figura A \nna posição correta, isto é, de modo a completar \nos desenhos. \n \n \n \n \nÉ possível preencher corretamente o espaço \nindicado pela seta no tabuleiro da figura A colo-\ncando a peça: \n \nA) 1 após girá-la 90° no sentido horário. \nB) 1 após girá-la 180° no sentido anti-horário. \nC) 2 após girá-la 90° no sentido anti-horário. \nD) 2 após girá-la 180° no sentido horário. \nE) 2 após girá-la 270° no sentido anti-horário.",
    "alternativas": {
      "C": "2 após girá-la 90° no sentido anti-horário.",
      "E": "2 após girá-la 270° no sentido anti-horário.",
      "A": "1 após girá-la 90° no sentido horário.",
      "B": "1 após girá-la 180° no sentido anti-horário."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 57,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0058",
    "numero": 1558,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A tabela mostra alguns dados da emissão de \ndióxido de carbono de uma fábrica, em função \ndo número de toneladas produzidas. \n \n \nOs dados na tabela indicam que a taxa média \nde variação entre a emissão de dióxido de car-\nbono (em ppm) e a produção (em toneladas) é: \n \nA) inferior a 0,18. \nB) superior a 0,18 e inferior a 0,50. \nC) superior a 0,50 e inferior a 1,50. \nD) superior a 1,50 e inferior a 2,80. \nE) superior a 2,80.",
    "alternativas": {
      "C": "superior a 0,50 e inferior a 1,50.",
      "D": "superior a 1,50 e inferior a 2,80.",
      "A": "inferior a 0,18.",
      "B": "superior a 0,18 e inferior a 0,50."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 58,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0059",
    "numero": 1559,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Em Florença, Itália, na Igreja de Santa Croce, é \npossível encontrar um portão em que aparecem \nos anéis de Borromeo. Alguns historiadores \nacreditavam que os círculos representavam as \ntrês artes: escultura, pintura e arquitetura, pois \nelas eram tão próximas quanto inseparáveis. \n \n \n \nQual dos esboços a seguir melhor representa os \nanéis de Borromeo? \n \nA) \n \n \nB) \n \n \nC) \n \nD) \n \n \nE)",
    "alternativas": {
      "E": "",
      "B": "",
      "C": "",
      "D": ""
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 59,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-0060",
    "numero": 1560,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Brasil e França têm relações comerciais há mais \nde 200 anos. Enquanto a França é a 5.ª nação \nmais rica do planeta, o Brasil é a 10.ª, e ambas \nse destacam na economia mundial. No entanto, \ndevido a uma série de restrições, o comércio \nentre esses dois países ainda não é adequada-\nmente explorado, como mostra a tabela seguin-\nte, referente ao período 2003-2007. \n \n \n \nOs dados da tabela mostram que, no período \nconsiderado, os valores médios dos investimen-\ntos da França no Brasil foram maiores que os \ninvestimentos do Brasil na França em um valor: \n \nA) inferior a 300 milhões de dólares. \nB) superior a 300 milhões de dólares, mas infe-\nrior a 400 milhões de dólares. \nC) superior a 400 milhões de dólares, mas infe-\nrior a 500 milhões de dólares. \nD) superior a 500 milhões de dólares, mas infe-\nrior a 600 milhões de dólares. \nE) superior a 600 milhões de dólares.",
    "alternativas": {
      "C": "superior a 400 milhões de dólares, mas infe- rior a 500 milhões de dólares.",
      "D": "superior a 500 milhões de dólares, mas infe- rior a 600 milhões de dólares.",
      "E": "superior a 600 milhões de dólares.",
      "B": "superior a 300 milhões de dólares, mas infe- rior a 400 milhões de dólares."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 60,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0061",
    "numero": 1561,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Um grupo de 50 pessoas fez um orçamento \ninicial para organizar uma festa, que seria divi-\ndido entre elas em cotas iguais. Verificou-se ao \nfinal que, para arcar com todas as despesas, \nfaltavam R$ 510,00, e que 5 novas pessoas \nhaviam ingressado no grupo. No acerto foi deci-\ndido que a despesa total seria dividida em par-\ntes iguais pelas 55 pessoas. Quem não havia \nainda contribuído pagaria a sua parte, e cada \numa das 50 pessoas do grupo inicial deveria \ncontribuir com mais R$ 7,00. \n \nDe acordo com essas informações, qual foi o \nvalor da cota calculada no acerto final para cada \numa das 55 pessoas? \n \nA) R$ 14,00.         \nB) R$ 17,00.         \nC) R$ 22,00.        \nD) R$ 32,00.         \nE) R$ 57,00.",
    "alternativas": {
      "D": "R$ 32,00.",
      "E": "R$ 57,00.",
      "A": "R$ 14,00.",
      "C": "R$ 22,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 61,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0062",
    "numero": 1562,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Técnicos concluem mapeamento  \ndo aquífero Guarani \n \nO aquífero Guarani localiza-se no subterrâneo \ndos territórios da Argentina, Brasil, Paraguai e \nUruguai, com extensão total de 1.200.000 qui-\nlômetros quadrados, dos quais 840.000 quilô-\nmetros quadrados estão no Brasil. O aquífero \narmazena cerca de 30 mil quilômetros cúbicos \nde água e é considerado um dos maiores do \nmundo. Na maioria das vezes em que são feitas \nreferências à água, são usadas as unidades \nmetro cúbico e litro, e não as unidades já descri-\ntas. A Companhia de Saneamento Básico do \nEstado de São Paulo (SABESP) divulgou, por \nexemplo, um novo reservatório cuja capacidade \nde armazenagem é de 20 milhões de litros. \n \nComparando as capacidades do aquífero Gua-\nrani e desse novo reservatório da SABESP, a \ncapacidade do aquífero Guarani é: \n \nA) 1,5 x 102 vezes a capacidade do reservatório \nnovo.  \nB) 1,5 x 103 vezes a capacidade do reservatório \nnovo.  \nC) 1,5 x 106 vezes a capacidade do reservatório \nnovo.  \nD) 1,5 x 108 vezes a capacidade do reservatório \nnovo.  \nE) 1,5 x 109 vezes a capacidade do reservatório \nnovo.",
    "alternativas": {
      "D": "1,5 x 108 vezes a capacidade do reservatório novo.",
      "E": "1,5 x 109 vezes a capacidade do reservatório novo.",
      "A": "1,5 x 102 vezes a capacidade do reservatório novo.",
      "B": "1,5 x 103 vezes a capacidade do reservatório novo."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 62,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0063",
    "numero": 1563,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Suponha que, na escultura do artista Emanoel \nAraújo, mostrada na figura a seguir, todos os \nprismas numerados em algarismos romanos \nsão retos, com bases triangulares, e que as \nfaces laterais do poliedro II são perpendiculares \nà sua própria face superior, que, por sua vez, é \num triângulo congruente ao triângulo base dos \nprismas. Além disso, considere que os prismas I \ne III são perpendiculares ao prisma IV e ao poli-\nedro II. \n \n \nImagine um plano paralelo à face α do prisma I, \nmas que passe pelo ponto P pertencente à \naresta do poliedro II, indicado na figura. A inter-\nseção desse plano imaginário com a escultura \ncontém: \n \nA) dois triângulos congruentes com lados cor-\nrespondentes paralelos. \nB) dois retângulos congruentes e com lados \ncorrespondentes paralelos. \nC) dois trapézios congruentes com lados cor-\nrespondentes perpendiculares. \nD) dois paralelogramos congruentes com lados \ncorrespondentes paralelos. \nE) dois quadriláteros congruentes com lados \ncorrespondentes perpendiculares.",
    "alternativas": {
      "C": "dois trapézios congruentes com lados cor- respondentes perpendiculares.",
      "E": "dois quadriláteros congruentes com lados correspondentes perpendiculares.",
      "A": "dois triângulos congruentes com lados cor- respondentes paralelos.",
      "B": "dois retângulos congruentes e com lados correspondentes paralelos."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 63,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0064",
    "numero": 1564,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A rampa de um hospital tem na sua parte mais \nelevada uma altura de 2,2 metros. Um paciente \nao caminhar sobre a rampa percebe que se \ndeslocou 3,2 metros e alcançou uma altura de \n0,8 metro. A distância em metros que o paciente \nainda deve caminhar para atingir o ponto mais \nalto da rampa é: \n \nA) 1,16 metros.        \nB) 3,0 metros.        \nC) 5,4 metros.         \nD) 5,6 metros.         \nE) 7,04 metros.",
    "alternativas": {
      "A": "1,16 metros.",
      "B": "3,0 metros.",
      "C": "5,4 metros.",
      "D": "5,6 metros."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 64,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0065",
    "numero": 1565,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Um posto de combustível vende 10.000 litros de \nálcool por dia a R$ 1,50 cada litro. Seu proprie-\ntário percebeu que, para cada centavo de des-\nconto que concedia por litro, eram vendidos 100 \nlitros a mais por dia. Por exemplo, no dia em \nque o preço do álcool foi R$ 1,48, foram vendi-\ndos 10.200 litros.  \nConsiderando x o valor, em centavos, do des-\nconto dado no preço de cada litro, e V o valor, \nem R$, arrecadado por dia com a venda do \nálcool, então a expressão que relaciona V e x é: \n \nA) V = 10.000 + 50x – x2.  \nB) V = 10.000 + 50x + x2.  \nC) V = 15.000 – 50x – x2.  \nD) V = 15.000 + 50x - x2.  \nE) V = 15.000 – 50x + x2.",
    "alternativas": {
      "D": "V = 15.000 + 50x - x2.",
      "E": "V = 15.000 – 50x + x2.",
      "B": "V = 10.000 + 50x + x2.",
      "C": "V = 15.000 – 50x – x2."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 65,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0066",
    "numero": 1566,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Para cada indivíduo, a sua inscrição no Cadas-\ntro de Pessoas Físicas (CPF) é composto por \num número de 9 algarismos e outro número de \n2 algarismos, na forma d1d2, em que os dígitos \nd1 e d2 são denominados dígitos verificadores. \nOs dígitos verificadores são calculados, a partir \nda esquerda, da seguinte maneira: os 9 primei-\nros algarismos são multiplicados pela sequência \n10, 9, 8, 7, 6, 5, 4, 3, 2 (o primeiro por 10, o \nsegundo por 9, e assim sucessivamente); em \nseguida, calcula-se o resto r da divisão da soma \ndos resultados das multiplicações por 11, e se \nesse resto r for 0 ou 1, d1 é zero, caso contrário \nd1 = (11 – r). O dígito d2 é calculado pela mesma \nregra, na qual os números a serem multiplica-\ndos pela sequência dada são contados a partir \ndo segundo algarismo, sendo d1 o último alga-\nrismo, isto é, d2 é zero se o resto s da divisão \npor 11 das somas das multiplicações for 0 ou 1, \ncaso contrário, d2 = (11 – s).  \n \nSuponha que João tenha perdido seus docu-\nmentos, inclusive o cartão de CPF e, ao dar \nqueixa da perda na delegacia, não conseguisse \nlembrar quais eram os dígitos verificadores, \nrecordando-se apenas que os nove primeiros \nalgarismos eram 123.456.789. Neste caso, os \ndígitos verificadores d1 e d2 esquecidos são, \nrespectivamente, \n \nA) 0 e 9.       \nB) 1 e 4.        \nC) 1 e 7.       \nD) 9 e 1.        \nE) 0 e 1.",
    "alternativas": {
      "C": "1 e 7.",
      "D": "9 e 1.",
      "E": "0 e 1.",
      "A": "0 e 9."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 66,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0067",
    "numero": 1567,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Uma empresa que fabrica esferas de aço, de 6 \ncm de raio, utiliza caixas de madeira, na forma \nde um cubo, para transportá-las. Sabendo que a \ncapacidade da caixa é de 13.824 cm³, então o \nnúmero máximo de esferas que podem ser \ntransportadas em uma caixa é igual a: \n \nA) 4.         \nB) 8.         \nC) 16.          \nD) 24.         \nE) 32.",
    "alternativas": {
      "B": "8.",
      "D": "24.",
      "E": "32.",
      "A": "4."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 67,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0068",
    "numero": 1568,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A figura a seguir mostra as medidas reais de \numa aeronave que será fabricada para utiliza-\nção por companhias de transporte aéreo. Um \nengenheiro precisa fazer o desenho desse avião \nem escala de 1:150. \n \n \n \nPara o engenheiro fazer esse desenho em uma \nfolha de papel, deixando uma margem de 1 cm \nem relação às bordas da folha, quais as dimen-\nsões mínimas, em centímetros, que essa folha \ndeverá ter? \n \nA) 2,9 cm × 3,4 cm. \nB) 3,9 cm × 4,4 cm. \nC) 20 cm × 25 cm. \nD) 21 cm × 26 cm. \nE) 192 cm × 242 cm.",
    "alternativas": {
      "A": "2,9 cm × 3,4 cm.",
      "B": "3,9 cm × 4,4 cm.",
      "C": "20 cm × 25 cm.",
      "D": "21 cm × 26 cm."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 68,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0069",
    "numero": 1569,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Um experimento consiste em colocar certa \nquantidade de bolas de vidro idênticas em um \ncopo com água até certo nível e medir o nível \nda água, conforme ilustrado na figura a seguir. \nComo resultado do experimento, concluiu-se \nque o nível da água é função do número de \nbolas de vidro que são colocadas dentro do \ncopo. \n \n \nO quadro a seguir mostra alguns resultados do \nexperimento realizado. \n \n \nQual a expressão algébrica que permite calcular \no nível da água (y) em função do número de \nbolas (x)? \n \nA) y = 30x. \nB) y = 25x + 20,2. \nC) y = 1,27x. \nD) y = 0,7x. \nE) y = 0,07x + 6.",
    "alternativas": {
      "C": "y = 1,27x.",
      "D": "y = 0,7x.",
      "E": "y = 0,07x + 6.",
      "B": "y = 25x + 20,2."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 69,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0070",
    "numero": 1570,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Uma cooperativa de colheita propôs a um fa-\nzendeiro um contrato de trabalho nos seguintes \ntermos: a cooperativa forneceria 12 trabalhado-\nres e 4 máquinas, em um regime de trabalho de \n6 horas diárias, capazes de colher 20 hectares \nde milho por dia, ao custo de R$ 10,00 por tra-\nbalhador por dia de trabalho, e R$ 1.000,00 pelo \naluguel diário de cada máquina. O fazendeiro \nargumentou que fecharia contrato se a coopera-\ntiva colhesse 180 hectares de milho em 6 dias, \ncom gasto inferior a R$ 25.000,00.  \n \nPara atender às exigências do fazendeiro e \nsupondo que o ritmo dos trabalhadores e das \nmáquinas seja constante, a cooperativa deveria: \n \nA) manter sua proposta. \nB) oferecer 4 máquinas a mais. \nC) oferecer 6 trabalhadores a mais. \nD) aumentar a jornada de trabalho para 9 horas \ndiárias. \nE) reduzir em R$ 400,00 o valor do aluguel diá-\nrio de uma máquina.",
    "alternativas": {
      "E": "reduzir em R$ 400,00 o valor do aluguel diá- rio de uma máquina.",
      "B": "oferecer 4 máquinas a mais.",
      "C": "oferecer 6 trabalhadores a mais.",
      "D": "aumentar a jornada de trabalho para 9 horas diárias."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 70,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0071",
    "numero": 1571,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Suponha que a etapa final de uma gincana es-\ncolar consista em um desafio de conhecimen-\ntos. Cada equipe escolheria 10 alunos para \nrealizar uma prova objetiva, e a pontuação da \nequipe seria dada pela mediana das notas obti-\ndas pelos alunos. As provas valiam, no máximo, \n10 pontos cada. Ao final, a vencedora foi a \nequipe Ômega, com 7,8 pontos, seguida pela \nequipe Delta, com 7,6 pontos. Um dos alunos \nda equipe Gama, a qual ficou na terceira e últi-\nma colocação, não pôde comparecer, tendo \nrecebido nota zero na prova. As notas obtidas \npelos 10 alunos da equipe Gama foram 10; 6,5; \n8; 10; 7; 6,5; 7; 8; 6; 0.  \n \nSe o aluno da equipe Gama que faltou tivesse \ncomparecido, essa equipe: \n \nA) teria a pontuação igual a 6,5 se ele obtivesse \nnota 0. \nB) seria a vencedora se ele obtivesse nota 10. \nC) seria a segunda colocada se ele obtivesse \nnota 8. \nD) permaneceria na terceira posição, indepen-\ndentemente da nota obtida pelo aluno. \nE) empataria com a equipe Ômega na primeira \ncolocação se o aluno obtivesse nota 9.",
    "alternativas": {
      "A": "teria a pontuação igual a 6,5 se ele obtivesse nota 0.",
      "C": "seria a segunda colocada se ele obtivesse nota 8.",
      "D": "permaneceria na terceira posição, indepen- dentemente da nota obtida pelo aluno.",
      "E": "empataria com a equipe Ômega na primeira colocação se o aluno obtivesse nota 9."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 71,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0072",
    "numero": 1572,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Uma escola lançou uma campanha para seus \nalunos arrecadarem, durante 30 dias, alimentos \nnão perecíveis para doar a uma comunidade \ncarente da região. Vinte alunos aceitaram a \ntarefa e nos primeiros 10 dias trabalharam 3 \nhoras diárias, arrecadando 12 kg de alimentos \npor dia. Animados com os resultados, 30 novos \nalunos somaram-se ao grupo, e passaram a \ntrabalhar 4 horas por dia nos dias seguintes até \no término da campanha.  \n \nAdmitindo-se que o ritmo de coleta tenha se \nmantido constante, a quantidade de alimentos \narrecadados ao final do prazo estipulado seria \nde: \n \nA) 920 kg.       \nB) 800 kg.       \nC) 720 kg.        \nD) 600 kg.        \nE) 570 kg.",
    "alternativas": {
      "E": "570 kg.",
      "A": "920 kg.",
      "B": "800 kg.",
      "D": "600 kg."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 72,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0073",
    "numero": 1573,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Segundo as regras da Fórmula 1, o peso míni-\nmo do carro, de tanque vazio, com o piloto, é de \n605 kg, e a gasolina deve ter densidade entre \n725 e 780 gramas por litro. Entre os circuitos \nnos quais ocorrem competições dessa catego-\nria, o mais longo é Spa-Francorchamps, na Bél-\ngica, cujo traçado tem 7 km de extensão. O \nconsumo médio de um carro da Fórmula 1 é de \n75 litros para cada 100 km.  \n \nSuponha que um piloto de uma equipe específi-\nca, que utiliza um tipo de gasolina com densida-\nde de 750 g/L, esteja no circuito de Spa-\nFrancorchamps, parado no box para reabaste-\ncimento. Caso ele pretenda dar mais 16 voltas, \nao ser liberado para retornar à pista, seu carro \ndeverá pesar, no mínimo, \n \nA) 617 kg.        \nB) 668 kg.         \nC) 680 kg.       \nD) 689 kg.          \nE) 717 kg.",
    "alternativas": {
      "E": "717 kg.",
      "A": "617 kg.",
      "B": "668 kg.",
      "C": "680 kg."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 73,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0074",
    "numero": 1574,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Ao morrer, o pai de João, Pedro e José deixou \ncomo herança um terreno retangular de 3 km x \n2 km que contém uma área de extração de ouro \ndelimitada por um quarto de círculo de raio 1 km \na partir do canto inferior esquerdo da proprieda-\nde. Dado o maior valor da área de extração de \nouro, os irmãos acordaram em repartir a propri-\nedade de modo que cada um ficasse com a \nterça parte da área de extração, conforme mos-\ntra a figura. \n \n \n \nEm relação à partilha proposta, constata-se que \na porcentagem da área do terreno que coube a \nJoão corresponde, aproximadamente, a: \n \n \n(considere √3\n3  = 0,58) \n \nA) 50%.     \nB) 43%.    \nC) 37%.      \nD) 33%.      \nE) 19%.",
    "alternativas": {
      "D": "33%.",
      "E": "19%.",
      "B": "43%.",
      "C": "37%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 74,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0075",
    "numero": 1575,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Doze times se inscreveram em um torneio de \nfutebol amador. O jogo de abertura do torneio \nfoi escolhido da seguinte forma: primeiro foram \nsorteados 4 times para compor o Grupo A.  \n \nEm seguida, entre os times do Grupo A, foram \nsorteados 2 times para realizar o jogo de abertu-\nra do torneio, sendo que o primeiro deles jogaria \nem seu próprio campo, e o segundo seria o time \nvisitante.  \n \nA quantidade total de escolhas possíveis para o \nGrupo A e a quantidade total de escolhas dos \ntimes do jogo de abertura podem ser calculadas \natravés de: \n \nA) uma combinação e um arranjo, respectiva-\nmente. \nB) um arranjo e uma combinação, respectiva-\nmente. \nC) um arranjo e uma permutação, respectiva-\nmente. \nD) duas combinações. \nE) dois arranjos.",
    "alternativas": {
      "D": "duas combinações.",
      "E": "dois arranjos.",
      "A": "uma combinação e um arranjo, respectiva- mente.",
      "C": "um arranjo e uma permutação, respectiva- mente."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 75,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0076",
    "numero": 1576,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Rotas aéreas são como pontes que ligam cida-\ndes, estados ou países. O mapa a seguir mostra \nos estados brasileiros e a localização de algu-\nmas capitais identificadas pelos números. Con-\nsidere que a direção seguida por um avião AI \nque partiu de Brasília – DF, sem escalas, para \nBelém, no Pará, seja um segmento de reta com \nextremidades em DF e em 4. \n \n \nMAPA DO BRASIL E ALGUMAS CAPITAIS \n \n \n \nSuponha que um passageiro de nome Carlos \npegou um avião AII, que seguiu a direção que \nforma um ângulo de 135° graus no sentido horá-\nrio com a rota Brasília – Belém e pousou em \nalguma das capitais brasileiras. Ao desembar-\ncar, Carlos fez uma conexão e embarcou em \num avião AIII, que seguiu a direção que forma \num ângulo reto, no sentido anti-horário, com a \ndireção seguida pelo avião AII ao partir de Bra-\nsília-DF.  \n \nConsiderando que a direção seguida por um \navião é sempre dada pela semirreta com origem \nna cidade de partida e que passa pela cidade \ndestino do avião, pela descrição dada, o passa-\ngeiro Carlos fez uma conexão em: \n \nA) Belo Horizonte, e em seguida embarcou para \nCuritiba. \nB) Belo Horizonte, e em seguida embarcou para \nSalvador. \nC) Boa Vista, e em seguida embarcou para Por-\nto Velho. \nD) Goiânia, e em seguida embarcou para o Rio \nde Janeiro. \nE) Goiânia, e em seguida embarcou para Ma-\nnaus.",
    "alternativas": {
      "D": "Goiânia, e em seguida embarcou para o Rio de Janeiro.",
      "E": "Goiânia, e em seguida embarcou para Ma- naus.",
      "A": "Belo Horizonte, e em seguida embarcou para Curitiba.",
      "B": "Belo Horizonte, e em seguida embarcou para Salvador."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 76,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0077",
    "numero": 1577,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "O quadro apresenta informações da área apro-\nximada de cada bioma brasileiro. \n \n \nÉ comum em conversas informais, ou mesmo \nem noticiários, o uso de múltiplos da área de um \ncampo de futebol (com as medidas de 120 m x \n90 m) para auxiliar a visualização de áreas con-\nsideradas extensas. Nesse caso, qual é o nú-\nmero de campos de futebol correspondente à \nárea aproximada do bioma Pantanal? \n \nA) 1.400      \nB) 14.000      \nC) 140.000       \nD) 1.400.000       \nE) 14.000.000",
    "alternativas": {
      "B": "14.000",
      "D": "1.400.000",
      "E": "14.000.000",
      "A": "1.400"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 77,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0078",
    "numero": 1578,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Na tabela, são apresentados dados da cotação \nmensal do ovo extra branco vendido no ataca-\ndo, em Brasília, em reais, por caixa de 30 dú-\nzias de ovos, em alguns meses dos anos 2007 \ne 2008. \n \n \n \nDe acordo com esses dados, o valor da media-\nna das cotações mensais do ovo extra branco \nnesse período era igual a: \n \nA) R$ 73,10.     \nB) R$ 81,50.     \nC) R$ 82,00.     \nD) R$ 83,00.      \nE) R$ 85,30.",
    "alternativas": {
      "C": "R$ 82,00.",
      "D": "R$ 83,00.",
      "A": "R$ 73,10.",
      "B": "R$ 81,50."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 78,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0079",
    "numero": 1579,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A vazão do rio Tietê, em São Paulo, constitui \npreocupação constante nos períodos chuvosos. \nEm alguns trechos, são construídas canaletas \npara controlar o fluxo de água. Uma dessas \ncanaletas, cujo corte vertical determina a forma \nde um trapézio isósceles, tem as medidas espe-\ncificadas na figura I. Neste caso, a vazão da \nágua é de 1.050 m³/s. O cálculo da vazão, Q em \nm³/s, envolve o produto da área A do setor \ntransversal (por onde passa a água), em m², \npela velocidade da água no local, v, em m/s, ou \nseja, Q = Av.  \n \nPlaneja-se uma reforma na canaleta, com as \ndimensões especificadas na figura II, para evitar \na ocorrência de enchentes. \n \n \n \n \nNa suposição de que a velocidade da água não \nse alterará, qual a vazão esperada para depois \nda reforma na canaleta? \n \nA) 90 m3/s. \nB) 750 m3/s. \nC) 1.050 m3/s.  \nD) 1.512 m3/s. \nE) 2.009 m3/s.",
    "alternativas": {
      "D": "1.512 m3/s.",
      "A": "90 m3/s.",
      "B": "750 m3/s.",
      "C": "1.050 m3/s."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 79,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0080",
    "numero": 1580,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A resolução das câmeras digitais modernas é \ndada em megapixels, unidade de medida que \nrepresenta um milhão de pontos. As informa-\nções sobre cada um desses pontos são arma-\nzenadas, em geral, em 3 bytes. Porém, para \nevitar que as imagens ocupem muito espaço, \nelas são submetidas a algoritmos de compres-\nsão, que reduzem em até 95% a quantidade de \nbytes necessários para armazená-las. Conside-\nre 1 KB = 1.000 bytes, 1 MB = 1.000 KB, 1 GB = \n1.000 MB. \n \nUtilizando uma câmera de 2.0 megapixels cujo \nalgoritmo de compressão é de 95%, João foto-\ngrafou 150 imagens para seu trabalho escolar. \nSe ele deseja armazená-las de modo que o \nespaço restante no dispositivo seja o menor \nespaço possível, ele deve utilizar: \nA) um CD de 700 MB. \nB) um pendrive de 1 GB. \nC) um HD externo de 16 GB. \nD) um memory stick de 16 MB. \nE) um cartão de memória de 64 MB.",
    "alternativas": {
      "B": "um pendrive de 1 GB.",
      "C": "um HD externo de 16 GB.",
      "D": "um memory stick de 16 MB.",
      "E": "um cartão de memória de 64 MB."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 80,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0081",
    "numero": 1581,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "A população brasileira sabe, pelo menos intuiti-\nvamente, que a probabilidade de acertar as seis \ndezenas da mega sena não é zero, mas é qua-\nse. Mesmo assim, milhões de pessoas são atra-\nídas por essa loteria, especialmente quando o \nprêmio se acumula em valores altos. Até junho \nde 2009, cada aposta de seis dezenas, perten-\ncentes ao conjunto {01, 02, 03, ..., 59, 60}, cus-\ntava R$ 1,50. \n \nConsidere que uma pessoa decida apostar exa-\ntamente R$ 126,00 e que esteja mais interessa-\nda em acertar apenas cinco das seis dezenas \nda mega sena, justamente pela dificuldade des-\nta última. Nesse caso, é melhor que essa pes-\nsoa faça 84 apostas de seis dezenas diferentes, \nque não tenham cinco números em comum, do \nque uma única aposta com nove dezenas, por-\nque a probabilidade de acertar a quina no se-\ngundo caso em relação ao primeiro é, aproxi-\nmadamente, \n \nA) 1 \n1\n2 vez menor. \n \nB) 2 \n1\n2 vezes menor. \n \nC) 4 vezes menor. \n \nD) 9 vezes menor. \n \nE) 14 vezes menor.",
    "alternativas": {
      "E": "14 vezes menor.",
      "A": "1 1 2 vez menor.",
      "C": "4 vezes menor.",
      "D": "9 vezes menor."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 81,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0082",
    "numero": 1582,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Nos últimos anos, o volume de petróleo expor-\ntado pelo Brasil tem mostrado expressiva ten-\ndência de crescimento, ultrapassando as impor-\ntações em 2008. Entretanto, apesar de as im-\nportações terem se mantido praticamente no \nmesmo patamar desde 2001, os recursos gera-\ndos com as exportações ainda são inferiores \nàqueles despendidos com as importações, uma \nvez que o preço médio por metro cúbico do \npetróleo importado é superior ao do petróleo \nnacional. Nos primeiros cinco meses de 2009, \nforam gastos 2,84 bilhões de dólares com im-\nportações e gerada uma receita de 2,24 bilhões \nde dólares com as exportações. O preço médio \npor metro cúbico em maio de 2009 foi de 340 \ndólares para o petróleo importado e de 230 dó-\nlares para o petróleo exportado. O quadro a \nseguir mostra os dados consolidados de 2001 a \n2008 e dos primeiros cinco meses de 2009. \nComércio exterior de petróleo \n(milhões de metros cúbicos) \n \n \n*Valores apurados de janeiro a maio de 2009. \n \nConsidere que as importações e exportações de \npetróleo de junho a dezembro de 2009 sejam \niguais a 7/5 das importações e exportações, \nrespectivamente, ocorridas de janeiro a maio de \n2009. Nesse caso, supondo que os preços para \nimportação e exportação não sofram alterações, \nqual seria o valor mais aproximado da diferença \nentre os recursos despendidos com as importa-\nções e os recursos gerados com as exportações \nem 2009? \n \nA) 600 milhões de dólares. \nB) 840 milhões de dólares. \nC) 1,34 bilhão de dólares. \nD) 1,44 bilhão de dólares. \nE) 2,00 bilhões de dólares.",
    "alternativas": {
      "E": "2,00 bilhões de dólares.",
      "A": "600 milhões de dólares.",
      "B": "840 milhões de dólares.",
      "C": "1,34 bilhão de dólares."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 82,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0083",
    "numero": 1583,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Uma fábrica produz velas de parafina em forma \nde pirâmide quadrangular regular com 19 cm de \naltura e 6 cm de aresta da base. Essas velas \nsão formadas por 4 blocos de mesma altura — \n3 troncos de pirâmide de bases paralelas e 1 \npirâmide na parte superior —, espaçados de 1 \ncm entre eles, sendo que a base superior de \ncada bloco é igual à base inferior do bloco so-\nbreposto, com uma haste de ferro passando \npelo centro de cada bloco, unindo-os, conforme \na figura. \n \n \nSe o dono da fábrica resolver diversificar o mo-\ndelo, retirando a pirâmide da parte superior, que \ntem 1,5 cm de aresta na base, mas mantendo o \nmesmo molde, quanto ele passará a gastar com \nparafina para fabricar uma vela? \nA) 156 cm3.       \nB) 189 cm3.      \nC) 192 cm3.           \nD) 216 cm3.       \nE) 540 cm3.",
    "alternativas": {
      "B": "189 cm3.",
      "C": "192 cm3.",
      "E": "540 cm3.",
      "A": "156 cm3."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 83,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0085",
    "numero": 1585,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "O Indicador do CadÚnico (ICadÚnico), que \ncompõe o cálculo do Índice de Gestão Descen-\ntralizada do Programa Bolsa Família (IGD), é \nobtido por meio da média aritmética entre a \ntaxa de cobertura qualificada de cadastros (TC) \ne a taxa de atualização de cadastros (TA), em \nque TC = \nNV\nNF, TA = \nNA\nNV, NV é o número de ca-\ndastros domiciliares válidos no perfil do CadÚni-\nco, NF é o número de famílias estimadas como \npúblico alvo do CadÚnico e NA é o número de \ncadastros domiciliares atualizados no perfil do \nCadÚnico. \nSuponha que o IcadÚnico de um município es-\npecífico é 0,6. Porém, dobrando NF o IcadÚnico \ncairá para 0,5. Se NA + NV = 3.600, então NF é \nigual a: \n \nA) 10.000.     \nB) 7.500.       \nC) 5.000.     \nD) 4.500.      \nE) 3.000.",
    "alternativas": {
      "E": "3.000.",
      "B": "7.500.",
      "C": "5.000.",
      "D": "4.500."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.2",
    "numeroOriginal": 85,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];